import { useMutation } from "react-query";
import http from "infra/http";

function useAreaComumRegraReservaExcluirBloqueio(areaComumId: string, tenantId: string | null) {
  return useMutation(
    `/v1/tenants/${tenantId}/area-comum/${areaComumId}/regras-reserva`,
    (diaSemana: number) => {
      return http.delete(`/v1/tenants/${tenantId}/area-comum/${areaComumId}/regras-reserva/excluir-bloqueio/${diaSemana}`);
    },
    { retry: false, }
  );
}

export default useAreaComumRegraReservaExcluirBloqueio;
